import { useState, useEffect, useMemo } from "react";
import { fetchPlayerGameLog } from "../../../services/player-service";

export const usePitcherGameLog = ({ playerId, division }) => {
  const [allGames, setAllGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);

  useEffect(() => {
    if (!playerId) return;

    const controller = new AbortController();
    setLoading(true);
    setAllGames([]);
    setError(null);
    setSelectedYear(null);

    fetchPlayerGameLog(playerId, division, controller.signal)
      .then((data) => {
        if (controller.signal.aborted) return;
        const games = Array.isArray(data) ? data : [];
        setAllGames(games);
        if (games.length > 0) setSelectedYear(games[0].year);
      })
      .catch((err) => {
        if (err?.name === "AbortError") return;
        setError("Could not load game log");
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });

    return () => controller.abort();
  }, [playerId, division]);

  const availableYears = useMemo(
    () => [...new Set(allGames.map((g) => g.year))].sort((a, b) => b - a),
    [allGames]
  );

  const games = useMemo(
    () => (selectedYear ? allGames.filter((g) => g.year === selectedYear) : allGames),
    [allGames, selectedYear]
  );

  return { allGames, games, loading, error, selectedYear, setSelectedYear, availableYears };
};
